import React, { useEffect, useState, useCallback } from "react";
import ContractsView from "./ContractsView";
import { getMyContracts } from "../../../api/contractsApi";
import { deleteContract } from "../../../api/contractApi";
import { Spinner, ErrorState } from "../../../components/panel/PanelUI";

const LIMIT = 200;

export default function ContractsTab({ onViewContract }) {
  const [contracts, setContracts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadData = useCallback(
    (targetPage) => {
      setLoading(true);
      setError("");
      getMyContracts({ page: targetPage, limit: LIMIT, status: statusFilter })
        .then((data) => {
          setContracts(data?.contracts || data || []);
          setTotalPages(data?.totalPages || 1);
        })
        .catch((err) => setError(err.message))
        .finally(() => setLoading(false));
    },
    [statusFilter],
  );

  const handleDelete = (contractId) => {
    if (
      !window.confirm(
        "آیا از حذف این قولنامه مطمئن هستید؟ این عمل قابل بازگشت نیست.",
      )
    )
      return;
    setLoading(true);
    deleteContract(contractId)
      .then(() => {
        // reload current page
        loadData(page);
      })
      .catch((err) => {
        setError(err.message || "خطا در حذف قولنامه");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData(page);
  }, [loadData, page]);

  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setPage(1);
  };

  if (loading) return <Spinner label="در حال دریافت قولنامه‌ها..." />;
  if (error)
    return <ErrorState message={error} onRetry={() => loadData(page)} />;

  return (
    <ContractsView
      contracts={contracts}
      statusFilter={statusFilter}
      onStatusFilterChange={handleStatusChange}
      page={page}
      totalPages={totalPages}
      onPageChange={setPage}
      onView={onViewContract}
      onDelete={handleDelete}
    />
  );
}
